export const LIST_PATIENT_CENTER_REQUEST = 'LIST_PATIENT_CENTER_REQUEST'
export const LIST_PATIENT_CENTER_SUCCESS = 'LIST_PATIENT_CENTER_SUCCESS'
export const LIST_PATIENT_CENTER_FAIL = 'LIST_PATIENT_CENTER_FAIL'

export const DETAIL_PATIENT_CENTER_REQUEST = 'DETAIL_PATIENT_CENTER_REQUEST'
export const DETAIL_PATIENT_CENTER_SUCCESS = 'DETAIL_PATIENT_CENTER_SUCCESS'
export const DETAIL_PATIENT_CENTER_FAIL = 'DETAIL_PATIENT_CENTER_FAIL'

export const UPDATE_PATIENT_CENTER_REQUEST = 'UPDATE_PATIENT_CENTER_REQUEST'
export const UPDATE_PATIENT_CENTER_SUCCESS = 'UPDATE_PATIENT_CENTER_SUCCESS'
export const UPDATE_PATIENT_CENTER_FAIL = 'UPDATE_PATIENT_CENTER_FAIL'

export const CONFIRM_PATIENT_CENTER_REQUEST = 'CONFIRM_PATIENT_CENTER_REQUEST'
export const CONFIRM_PATIENT_CENTER_SUCCESS = 'CONFIRM_PATIENT_CENTER_SUCCESS'
export const CONFIRM_PATIENT_CENTER_FAIL = 'CONFIRM_PATIENT_CENTER_FAIL'